import axios from 'axios'
import { getBaseURL } from '../utils/helper';

console.log('process.env.API_DEV_URL: ', process.env.REACT_APP_API_DEV_URL)
export default axios.create({
  baseURL: getBaseURL(),
});
